import { RegionType } from "graphql/generated";

export const CURRENCY_BY_COUNTRY = {
  [RegionType.Sg]: "$",
  [RegionType.Hk]: "HK$",
  [RegionType.Jp]: "¥"
};
